import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import TestingGate from "./components/TestingGate";
import "./index.css";
import { installAudioUnlock } from "./games/shared/sound";
import { installNetworkGuard } from "./lib/networkGuard";
import { installFrameGuard } from "./lib/frameGuard";

// Privacy: install before anything else can issue requests.
installNetworkGuard();
// Clickjacking: defense-in-depth on top of edge X-Frame-Options / frame-ancestors.
installFrameGuard();
installAudioUnlock();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <TestingGate>
      <App />
    </TestingGate>
  </HelmetProvider>,
);
